import moment from 'moment';
import { sendSlackNotification } from '../../functions';
import AsyncStorage from '../../async-storage';
import purgeClientLogs from './purgeClientLogs';

let currentlyWriting;

const awaitUntilDoneSubmitting = async () =>
  new Promise((resolve) => {
    const timerCheckSubmitted = setInterval(() => {
      if (!currentlyWriting) {
        // console.devLog.info('All clear to write anew...');
        resolve();
        clearInterval(timerCheckSubmitted);
      } else {
        // console.devLog.info('Tried workout submit while another ongoing, polling...');
      }
    }, 100);
  });
const logApiCall = async (args) => {
  return;
  console.devLog.info('log api call...');

  const { response, body, query, url, forceLog = false } = args;

  // Skip it ifs a normal API call and has no body AND no query
  if (!forceLog && response && response.ok && !body && !query) {
    // console.devLog.info('Skipping call for: ', url, 'query: ', query);
    // console.devLog.info('URL:', url, 'query: ', query);
    // console.devLog.info('Response:', response, 'response ok?', response.ok);
    // console.devLog.info('Body:', body);
    // console.devLog.info('Query: ', query);
    // console.devLog.info('We are cancelling the call logging...');
    return null;
  }
  // console.devLog.info('Logging call for: ', url, 'query: ', query, 'body: ', body);

  // Waits until any other things are done writing
  await awaitUntilDoneSubmitting();

  currentlyWriting = true;
  try {
    // await AsyncStorage.removeItem('@Nerdfitness:clientLog');
    const today = moment().format('YYYY-MM-DD');

    let todayClientLog = await AsyncStorage.getItem(
      `@Nerdfitness:clientLog-${today}`,
    );

    if (!todayClientLog || todayClientLog.length === 0) {
      // No entries for today, go ahead and purge back
      purgeClientLogs();
      todayClientLog = '';
    }

    // If the log is over 1MB, stop adding to it
    const logSize = todayClientLog.length;
    // console.devLog.info('SIZE:', logSize);
    if (logSize.length > 500000) {
      sendSlackNotification({
        title: 'Log file over 500kb',
        datetime: new Date().toDateString(),
        message: `Client logs too large for: url: ${JSON.stringify(
          url,
        )}, query: ${JSON.stringify(query)}, body: ${JSON.stringify(
          body,
        )}, length: ${logSize}`,
        env: 'LogApiCall function',
        platformName: 'CMA',
      });

      sendSlackNotification({
        title: "Today's Client Log:",
        datetime: new Date().toDateString(),
        message: todayClientLog,
        env: 'LogApiCall function',
        platformName: 'CMA',
      });

      return null;
    }

    // console.devLog.info('Client log:', clientLog);
    const callObject = {
      ...args,
      timestamp: new Date().toISOString(),
    };

    todayClientLog =
      todayClientLog === ''
        ? JSON.stringify(callObject)
        : `${todayClientLog},${JSON.stringify(callObject)}`;

    // console.devLog.info('whole today client log:', `[${todayClientLog}]`);
    await AsyncStorage.setItem(
      `@Nerdfitness:clientLog-${today}`,
      todayClientLog,
    );
  } catch (e) {
    console.devLog.info('Error appending item to client logs: ', e);
  } finally {
    currentlyWriting = false;
  }

  return null;
};

export default logApiCall;
